import { useQuery } from '@tanstack/react-query';

import {
  GET_COMPLIMENTARY_USAGE,
  type ComplimentaryUsageResponse,
} from '../../contracts';
import { getComplimentaryUsage } from '../api/credit-allowance';
import { getCommerceDataConfig } from '../config';
import { CREDIT_ALLOWANCE_STALE_TIME_MS } from './useQueryCreditAllowance';

export type UseQueryComplimentaryUsageProps = {
  hasUser: boolean;
  enabled?: boolean;
};

export function useQueryComplimentaryUsage({
  hasUser,
  enabled = true,
}: UseQueryComplimentaryUsageProps) {
  const { useAuthToken } = getCommerceDataConfig();
  const token = useAuthToken();

  return useQuery({
    queryKey: [GET_COMPLIMENTARY_USAGE],
    enabled: enabled && !!token && hasUser,
    staleTime: CREDIT_ALLOWANCE_STALE_TIME_MS,
    queryFn: async (): Promise<ComplimentaryUsageResponse> => {
      const { data } = await getComplimentaryUsage();
      return data ?? null;
    },
  });
}
